import React from 'react';
import { Layout } from '../components/layout/Layout';
import { ComicHeading } from '../components/ComicPanel';

const Terms = () => {
  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
        <ComicHeading as="h1" className="text-4xl mb-8" data-testid="terms-title">
          Terms of Service
        </ComicHeading>

        <div className="prose prose-invert prose-slate max-w-none">
          <p className="text-slate-300 mb-6">
            Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
          </p>

          <section className="mb-8">
            <h2 className="text-yellow-500 uppercase font-bold tracking-widest text-xl mb-4">
              1. Acceptance of Terms
            </h2>
            <p className="text-slate-300">
              By accessing and using PorkCops.com, you accept and agree to be bound by these 
              Terms of Service. If you do not agree to these terms, please do not use our service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-yellow-500 uppercase font-bold tracking-widest text-xl mb-4">
              2. Account Registration
            </h2>
            <p className="text-slate-300 mb-4">To access members-only content, you must:</p>
            <ul className="list-disc list-inside text-slate-300 space-y-2">
              <li>Provide accurate registration information</li>
              <li>Verify your email address</li>
              <li>Maintain the security of your account credentials</li>
              <li>Be at least 13 years of age</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-yellow-500 uppercase font-bold tracking-widest text-xl mb-4">
              3. Content and Intellectual Property
            </h2>
            <p className="text-slate-300 mb-4">
              All content on PorkCops.com, including but not limited to comics, artwork, text, 
              and graphics, is the property of Melted Port Studios and is protected by copyright law.
            </p>
            <p className="text-slate-300">
              You may not reproduce, distribute, or create derivative works from our content 
              without explicit written permission.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-yellow-500 uppercase font-bold tracking-widest text-xl mb-4">
              4. Acceptable Use
            </h2>
            <p className="text-slate-300 mb-4">You agree not to:</p>
            <ul className="list-disc list-inside text-slate-300 space-y-2">
              <li>Share your account credentials with others</li>
              <li>Attempt to circumvent access restrictions</li>
              <li>Use automated tools to access or download content</li>
              <li>Redistribute or resell any content</li>
              <li>Use the service for any illegal purpose</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-yellow-500 uppercase font-bold tracking-widest text-xl mb-4">
              5. Termination
            </h2>
            <p className="text-slate-300">
              We reserve the right to terminate or suspend your account at any time for 
              violations of these terms or for any other reason at our discretion.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-yellow-500 uppercase font-bold tracking-widest text-xl mb-4">
              6. Disclaimers
            </h2>
            <p className="text-slate-300">
              The service is provided "as is" without warranties of any kind. We do not 
              guarantee uninterrupted access to the service.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-yellow-500 uppercase font-bold tracking-widest text-xl mb-4">
              7. Limitation of Liability
            </h2>
            <p className="text-slate-300">
              To the maximum extent permitted by law, Melted Port Studios shall not be liable 
              for any indirect, incidental, or consequential damages arising from your use of 
              the service.
            </p>
          </section>

          <section>
            <h2 className="text-yellow-500 uppercase font-bold tracking-widest text-xl mb-4">
              8. Contact
            </h2>
            <p className="text-slate-300">
              For questions about these terms, contact us at{' '}
              <a href="mailto:legal@porkcops.com" className="text-yellow-500 hover:text-yellow-400">
                legal@porkcops.com
              </a>
            </p>
          </section>
        </div>
      </div>
    </Layout>
  );
};

export default Terms;
